import type { User } from './common';

// Plan & subscription marketing is only for Individual and Self-serve clients,
// never Enterprise (CL-6453). Enterprise pricing is handled off-platform.
export const isPlansEligible = (user: User | null | undefined): boolean =>
  Boolean(user?.isCompanyIndividual || user?.isCompanySelfServe);
